import { NgModule } from "@angular/core";
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireStorageModule } from '@angular/fire/storage';

@NgModule({
    imports: [
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        AngularFireStorageModule,
    ],
    exports: [
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        AngularFireStorageModule,
    ]
})

export class FirebaseModule{}